import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { type ColumnDef } from '@tanstack/react-table'
import { PlusIcon } from 'lucide-react'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { CardExtendTable } from '@/components/ui/card-extend'

import { productCategoryApi } from '@/features/product/api/product-category-api'
import type { ProductCategorySelectDto } from '@/features/product/schema/product-category-schema'

import { useAuth } from '@/lib/auth'

export const Route = createFileRoute('/_app/product/category/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <CategoryTable />
    </Page>
  )
}

function CategoryTable() {
  const navigate = Route.useNavigate()
  const outletId = useAuth().outlet.oId

  const { isLoading, data } = useQuery(productCategoryApi.list.query({ params: { outletId } }))

  const columns = useMemo(getColumns, [])
  const table = useDataTable({
    columns,
    data: data?.data.categories ?? [],
    isLoading,
    onRowClick: row =>
      navigate({ to: '/product/category/$id/update', params: { id: row.original.id } }),
  })

  return (
    <CardExtendTable
      title='Daftar Kategori Produk'
      action={
        <Button asChild size='sm'>
          <Link from={Route.fullPath} to='/product/category/create'>
            <PlusIcon /> Tambah Kategori
          </Link>
        </Button>
      }
    >
      <DataTable.Root table={table}>
        <DataTable.Table />
        <DataTable.Pagination />
      </DataTable.Root>
    </CardExtendTable>
  )
}

function getColumns(): ColumnDef<ProductCategorySelectDto>[] {
  return [
    {
      accessorKey: 'name',
      header: 'Nama Kategori',
      cell: ({ row }) => (
        <Cell.Link
          from={Route.fullPath}
          to='/product/category/$id/update'
          params={{ id: row.original.id }}
        >
          {row.original.name}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'isActive',
      header: 'Aktif',
      cell: ({ row }) => <Cell.Text text={row.original.isActive ? 'Yes' : 'No'} />,
    },
    {
      accessorKey: 'createdAt',
      header: 'Created At',
      cell: ({ row }) => <Cell.Date date={row.original.createdAt} />,
    },
    {
      accessorKey: 'updatedAt',
      header: 'Updated At',
      cell: ({ row }) => <Cell.Date date={row.original.updatedAt} />,
    },
    // {
    //   id: 'actions',
    //   header: () => <CellTextHeader text='Aksi' align='center' />,
    //   cell: ({ row }) => {
    //     return (
    //       <CellContent className='flex items-center justify-center gap-2'>
    //         {/* <Link
    // 					from={Route.fullPath}
    // 					to={`/product/category/${row.original.id}/update`}
    // 				>
    // 					<Pencil />
    // 				</Link> */}
    //       </CellContent>
    //     )
    //   },
    // },
  ]
}
